<template lang="jade">
  dropdown(":open.sync"="show"
           ":options"="fdata.options"
           ":callback"="select"
           ":active"="active"
           ":disabled"="!fdata.editable")
    dynamic-input("slot"="Dropdown__field"
                  ":model"="selected.label"
                  ":schema"="input"
                  ":callbacks"="callbacks"
                  ":disabled"="!fdata.editable")
  div.Error(v-if="errors" 
            class="animated" 
            transition="fade"
            style="margin: -1em 1em 0") 
      p.Error__msg {{ errors }}                  
</template>
<script>
  import _ from 'lodash'
  import dropdown from './dropdown.vue'
  import input from 'src/components/inputs/dynamic/input'
  import {removeNotification,
          addNotification,
          setWorkflow} from 'src/vuex/actions'
  import {forms, workflow, config} from 'src/vuex/getters'
  import { Submit } from 'src/services/resources'

  export default {
    data () {
      return {
        attempts: 0,
        selected: {
          value: '',
          label: '',
          onChange: false
        },
        uid: this.$parent.uid,
        complete: false,
        error: false,
        show: false,
        errors: null,
        active: 0
      }
    },
    components: {
      'dynamic-input': input,
      dropdown
    },
    props: {
      fdata: {
        type: Object,
        coerce (val) {
          if (!_.isUndefined(val.options) && val.options.length > 0) {
            val.options[0].label = '--Please select--'
          }
          return val
        }
      },
      idx: {
        type: Number,
        default: 0
      }
    },
    vuex: {
      getters: {
        forms,
        workflow,
        config
      },
      actions: {
        addNotification,
        removeNotification,
        setWorkflow
      }
    },
    created () {
      if (!_.includes(['TypeMultipart'], this._context.constructor.name)) {
        let vuex = _.find(this.forms, ['uid', this.uid])
        if (vuex) {
          let formData = vuex.data[this.fdata.field]
          if (formData) {
            this.fdata.value = formData
          }
        }
      }
      if (!this.fdata.options) this.getOptions()
      if (this.fdata.value && this.fdata.field) {
        this.preSelect()
      }
    },
    computed: {
      input () {
        return {
          type: 'text',
          label: this.fdata.label,
          placeholder: '--Please select--',
          required: _.some(this.fdata.validation, ['rule', 'required']) || this.$parent.mandatory,
          readOnly: true,
          complete: this.complete,
          error: this.error
        }
      },
      headers () {
        let header = _.find(this.workflow, ['uid', this.uid])
        return {
          headers: {
            'X-FORMID': header.fid,
            'X-FINGERPRINT': header.fingerprint,
            'X-SITEID': header.sid
          }
        }
      },
      callbacks () {
        return {
          focus: null,
          click: null,
          cycleUp: (e) => {
            e.preventDefault()
            e.stopPropagation()
            this.active = (this.active <= 0) ? this.fdata.options.length - 1
                                             : this.active - 1
          },
          cycleDown: (e) => {
            e.preventDefault()
            e.stopPropagation()
            if ((this.active + 1) >= this.fdata.options.length) {
              this.active = 0
            } else {
              this.active++
            }
          },
          tabBefore: () => { this.show = false },
          tabAfter: () => { this.show = true }
        }
      }
    },

    watch: {
      // selected: 'onChangeEvent',
      'fdata.value': 'preSelect',
      show: 'toggleClickaway'
    },

    events: {
      'clear': 'reset',
      'set': 'insert',
      'force::validate' () {
        this.attempts = 1
        this.validate()
      },
      'external::error' (errors) {
        if (errors[this.fdata.field]) {
          this.$set('error', true)
        }
      }
    },

    methods: {
      getOptions () {
        let parent = this.$parent.fdata
        let {field, row} = this.fdata
        this.$set('fdata.options', _.has(parent, ['options', field, row]) ? parent.options[field][row] : [])
      },
      preSelect () {
        let selected = _.find(this.fdata.options,
                              ['value', this.fdata.value])
        if (selected === undefined) return false
        this.$set('selected', {
          value: selected.value,
          label: selected.label,
          onChange: false
        })
      },
      toggleClickaway (active) {
        setTimeout(() => {
          active ? document.addEventListener('click', this.clickaway)
                 : document.removeEventListener('click', this.clickaway)
        }, 500)
      },

      insert (data) {
        let v = data[this.fdata.field]
        if (v !== undefined) {
          this.$set('selected', _.omit(_.find(this.fdata.options, ['value', v]), ['tip']))
        }
      },

      reset () {
        this.$set('selected', { value: '', label: '' })
        return true
      },

      descendant (parent, node) {
        if (node === null) return false
        return (node === parent) || this.descendant(parent, node.parentNode)
      },

      clickaway (e) {
        let el = this.$els.modal
        let target = e.target
        if ((el !== target) && !this.descendant(el, target)) this.close()
      },
      select (val) {
        this.$set('selected', _.pick(val, ['value', 'label']))
        this.attempts++
        this.validate()
        this.show = false
      },

      validate () {
        let validated = this.computedValidate(this.fdata, this.selected.value)
        this.attempts > 0 && validated ? this.setError() : this.setComplete()
        this.notice('error', validated)
        if (this.config.inlineErrors && _.gt(this.attempts, 0)) {
          this.$set('errors', validated)
        }
        if (_.isNil(validated) && this.fdata.field && this.fdata.editable) this.dispatch()
      },

      notice (type, valid) {
        _.isNil(valid) || _.isEmpty(valid)
          ? this.removeNotification(this.fdata.field)
          : this.addNotification({
            type: type,
            msg: valid,
            id: this.fdata.field,
            show: this.config.inlineErrors ? false : _.gt(this.attempts, 0)
          })
      },

      setError () {
        this.error = true
        this.complete = false
      },

      setComplete () {
        this.error = false
        this.complete = true
      },

      toggle () {
        this.show = !this.show
      },

      close () {
        this.$set('show', false)
      },

      focus () {
        this.$set('show', true)
      },

      success (res) {
        let evt = {'top': 'set::workflow',
                   'normal': 'add::workflow',
                   'popUp': 'modal::workflow',
                   'newWindow': 'tab::workflow'}
        let {data} = res
        let workflow = _.isUndefined(data.content) ? data : data.content
        workflow.fingerprint = data.fingerprint
        this.$dispatch(evt[this.fdata.onChange.openAs], workflow)
      },

      dispatch () {
        this.$dispatch('fdata::input',
                       {[this.fdata.field]: this.selected.value},
                       this.idx)
  
        if (_.isUndefined(this.selected.onChange) &&
            this.fdata.onChange.actions.length > 0) this.onChangeEvent()
      },

      onChangeEvent () {
        let form = _.find(this.forms, ['uid', this.uid])
        let currState = _.has(form, 'data') ? form.data : {[this.fdata.field]: this.selected.value}
        let formData = Object.assign(currState,
                                     {onChangeField: this.fdata.field,
                                      button: 'onChange'})
        this.$dispatch('loader::spinner', true)
        Submit.post(formData, this.headers)
          .then(this.success)
          .catch(this.failed)
      }
    },

    ready () {
      this.validate()
    }
  }
</script>



// WEBPACK FOOTER //
// custom-select.vue?48680b12